import { __decorate } from "tslib";
import { AutoEncoder, field, StringDecoder } from '@common/encoding';
export class SignupResponse extends AutoEncoder {
    /**
     * Token used to validate the code
     */
    token;
}
__decorate([
    field({ decoder: StringDecoder })
], SignupResponse.prototype, "token", void 0);
//# sourceMappingURL=SignupResponse.js.map